module.exports = __webpack_public_path__ + "static/media/art66.5551031c.jpg";